var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-recaptcha',{attrs:{"sitekey":_vm.googleCaptchaSiteKey},on:{"verify":_vm.recaptchaVerified}}),_vm._v(" recaptchaToken: "+_vm._s(_vm.recaptchaToken)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }